// React things
import { useRef, useState } from "react";

// Styles
import style from "./Referrer.module.css";

// Components
import Fren from "../Components/Fren/Fren.jsx";
import CustomCardsSwiper from "../Components/CustomCardsSwiper/CustomCardsSwiper.jsx";

// Stores
import useApplicationSettings from "../Store/ApplicationSettings.js";

// Services
import {
  refClaim,
  refClaimUSDT,
  sendRefLinkInBot,
} from "../Services/Requests.ts";

// Downloads Files
import avatar from "/avatar.png";
import people from "/people.png";
import card_background from "/card-background.png";
import card_background_usdt from "/card-background-usdt.png";
import stories_img from "/stories.png";
import toolsIcon from "../../assets/Icons/tools.svg";

// Services
import { getReferrers, getReferrersUSDT } from "../Services/Requests.ts";
import { useEffect } from "react";

// Hooks
import useRequestLock from "../Services/useRequestLock.js";
import { useNotificationStore } from "../Store/NotificationStore.ts";

export default function Referrer(props) {
  const [user, setUser] = useState({});
  const [userUSDT, setUserUSDT] = useState({});
  const [referrers, setReferrers] = useState([]);
  const [referrersUSDT, setReferrersUSDT] = useState([]);
  const [isClaimLoading, setIsClaimLoading] = useState(false);

  const [stories, setStories] = useState({});

  const setShowMenubar = useApplicationSettings(
    (state) => state.setShowMenubar
  );

  const localization = useApplicationSettings((state) => state.localization);

  const compToCopyRef = useRef(null);

  const [rewardType, setRewardType] = useState();

  const tg = window.Telegram?.WebApp || {
    HapticFeedback: {
      selectionChanged: () => {},
    },
    BackButton: {
      hide: () => {},
    },
    initDataUnsafe: {
      user: {
        id: null,
      },
    },
  };
  const currentUserId = tg.initDataUnsafe?.user?.id;
  const { isLocked, withLock } = useRequestLock();

  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );

  useEffect(() => {
    if (tg?.HapticFeedback?.selectionChanged) {
      tg.HapticFeedback.selectionChanged();
    }
    setShowMenubar(true);
    getReferrers((elements, user, storiesInfo) => {
      setUser(user);
      setReferrers(elements);
      setStories(storiesInfo);
    });
    getReferrersUSDT((elements, user) => {
      setUserUSDT(user);
      setReferrersUSDT(elements);
    });
    if (tg?.BackButton?.hide) {
      tg.BackButton.hide();
    }
  }, [tg, setShowMenubar]);
  console.log(referrersUSDT);
  return (
    <div className={style["container"]}>
      <>
        <div className={style["shadow"]}></div>
        <div className={style["container-wrapper"]}>
          <h3 className={style["title"]}>
            {localization["referrerPage_title"]}
          </h3>
          <div className={style["cards-wrapper"]}>
            <CustomCardsSwiper setRewardType={setRewardType}>
              <div className={style["card"]}>
                <div className={style["card-background-wrapper"]}>
                  <img
                    className={style["card-background"]}
                    src={card_background}
                  />
                </div>
                <div className={style["reward-container"]}>
                  <div className={style["reward"]}>
                    {Number(user?.amount_all || 0).toFixed(2)}
                    <div className={style["coin-type"]}>DC</div>
                  </div>
                  <div
                    onClick={() => {
                      withLock(async () => {
                        await new Promise((resolve) => {
                          refClaim(() => {
                            getReferrers((elements, user) => {
                              setUser(user);
                              setReferrers(elements);
                              resolve();
                            });
                          });
                        });
                      });
                    }}
                    className={`${style["claim"]} ${
                      isLocked ? style["disabled"] : ""
                    }`}
                  >
                    {localization["referrerPage_collect"]}
                  </div>
                </div>
              </div>
              <div className={style["card"]}>
                <div className={style["card-background-wrapper"]}>
                  <img
                    className={style["card-background"]}
                    src={card_background_usdt}
                  />
                </div>
                <div className={style["reward-container"]}>
                  <div className={style["reward"]}>
                    {Number(userUSDT?.amount_all || 0).toFixed(3)}
                    <div className={style["coin-type"]}>USDT</div>
                  </div>
                  <div
                    onClick={() => {
                      withLock(async () => {
                        await new Promise((resolve) => {
                          refClaimUSDT(() => {
                            getReferrersUSDT((elements, user) => {
                              setUserUSDT(user);
                              setReferrersUSDT(elements);
                              resolve();
                            });
                          }, setNotification);
                        });
                      });
                    }}
                    className={`${style["claim"]} ${
                      isLocked ? style["disabled"] : ""
                    }`}
                  >
                    {localization["referrerPage_collect"]}
                  </div>
                </div>
              </div>
            </CustomCardsSwiper>
          </div>

          <div className={style["description"]}>
            <div className={style["description1"]}>
              {localization["referrerPage_description1"]}
              <br />
              {localization["referrerPage_description2"]}
            </div>
            {/* <div className={style['description2']}>а также 10% с его заработка DC и USDT навсегда.</div> */}
          </div>
          <div className={style["fren-list-wrapper"]}>
            <div className={style["list-header"]}>
              <img src={people}></img>
              <div>
                {localization["referrerPage_friends"]} {referrers.length}
              </div>
            </div>

            <div className={style["fren-list"]}>
              {rewardType == 0
                ? referrers.map((referrer) => {
                    return (
                      <Fren
                        img={referrer.photo_url}
                        name={referrer.name}
                        reward={referrer?.all_sum.toFixed(3)}
                        link_profile={referrer?.link_profile}
                        coin_type={"DC"}
                      />
                    );
                  })
                : referrersUSDT.map((referrer) => {
                    return (
                      <Fren
                        img={referrer.photo_url}
                        name={referrer.name}
                        reward={referrer?.all_sum.toFixed(4)}
                        link_profile={referrer?.link_profile}
                        coin_type={"USDT"}
                      />
                    );
                  })}
            </div>
          </div>
          <textarea
            ref={compToCopyRef}
            className={style["textarea"]}
          ></textarea>
        </div>
        <div className={style["referral-buttons"]}>
          <div
            onClick={() => {
              if (user?.link == undefined) {
                setNotification({
                  type: "Error",
                  message: "Ссылка не найдена, обратитесь в поддержку",
                });
              } else {
                navigator.clipboard
                  .writeText(user?.link)
                  .then(() => {
                    setNotification({
                      type: "Success",
                      message: "Ссылка скопирована",
                    });
                    tg.HapticFeedback.notificationOccurred("success");
                  })
                  .catch(() => {
                    setNotification({
                      type: "Error",
                      message:
                        "Не смогли скопировать. Отправили реферальную ссылку вам в бота",
                    });
                    sendRefLinkInBot();
                  });
              }
            }}
            className={style["my-referal"]}
          >
            {localization["referrerPage_yourRefferalLink"]}
          </div>

          <div
            className={style["stories-post"]}
            onClick={() => {
              // not working()
              if (stories.media_url) {
                tg.shareToStory(stories.media_url, { text: stories?.text });
              }
            }}
          >
            <img className={style["stories-img"]} src={stories_img}></img>
          </div>
        </div>
      </>
    </div>
  );
}
